import React, { useContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import {
	IconButton,
	MenuItem,
	Menu as Select,
	Zoom,
	AppBar,
	Toolbar,
	Typography,
	CssBaseline,
	useScrollTrigger,
	Fab,
	Grid,
	ListItemIcon,
	Chip,
} from '@mui/material';
import {
	Add,
	ArrowBack,
	Delete,
	Edit,
	Elderly,
	FilterList,
	History,
	Menu,
	NextPlan,
	DateRange,
} from '@mui/icons-material';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import OrdersContext from '../../Context/Orders/OrdersContext';
import SwipeableMenu from '../SwipeableMenu/SwipeableMenu';

function ElevationScroll(props) {
	const { children, window } = props;

	const trigger = useScrollTrigger({
		disableHysteresis: true,
		threshold: 0,
		target: window ? window() : undefined,
	});

	return React.cloneElement(children, {
		elevation: trigger ? 4 : 0,
	});
}

ElevationScroll.propTypes = {
	children: PropTypes.element.isRequired,
	window: PropTypes.func,
};
export default function AppBarTest({ props, children }) {
	const {
		toogleNewOrderDialog,
		deleteSpecificOrder,
		currentOrderId,
		setCurrentOrderId,
		onChangeFilterOption,
		filterOption,
	} = useContext(OrdersContext);
	const [anchorEl, setAnchorEl] = useState(null);
	const [inZoom, setInZoom] = useState(false);

	const location = useLocation();
	const navigate = useNavigate();
	const { orderId } = useParams();

	const filterOptions = [
		{
			label: 'Más recientes',
			value: 'recents',
			icon: <History fontSize='small' />,
		},
		{
			label: 'Próxima entrega',
			value: 'next',
			icon: <NextPlan fontSize='small' />,
		},
		{
			label: 'Lejana entrega',
			value: 'distant',
			icon: <DateRange fontSize='small' />,
		},
		{
			label: 'Más antiguo',
			value: 'oldest',
			icon: <Elderly fontSize='small' />,
		},
	];

	useEffect(() => {
		if (location.pathname === '/') {
			setInZoom(true);
		} else {
			setInZoom(false);
		}
	}, [location]);

	const handleMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const IconFontSizeResponsive = { fontSize: { xs: '1.2rem', xsm: '1.5rem' } };
	const [drawerIsOpen, setDrawerIsOpen] = useState(false);

	return (
		<>
			<CssBaseline />
			<ElevationScroll {...props}>
				<AppBar color='white'>
					<Toolbar>
						{location.pathname === '/' ? (
							<IconButton
								size='large'
								edge='start'
								color='inherit'
								aria-label='menu'
								onClick={() => setDrawerIsOpen(!drawerIsOpen)}
							>
								<Menu sx={IconFontSizeResponsive} />
							</IconButton>
						) : (
							<IconButton
								size='large'
								edge='start'
								color='inherit'
								aria-label='menu'
								// sx={{ mr: 2 }}
								onClick={() => {
									navigate(-1);
									setCurrentOrderId('');
								}}
							>
								<ArrowBack sx={IconFontSizeResponsive} />
							</IconButton>
						)}
						<Typography variant='h5' component='div' sx={{ flexGrow: 1 }}>
							{location.pathname === '/' && 'Pedidos'}
							{location.pathname === `/${orderId}/view` && 'Detalles de pedido'}
							{location.pathname === `/${orderId}/edit` && 'Editar pedido'}
							{location.pathname === `/orders-history` &&
								'Historial de pedidos'}
						</Typography>

						{location.pathname === '/' && filterOption && (
							<Chip
								label={filterOption.label}
								variant='filled'
								color='primary'
								size='small'
								onDelete={() => onChangeFilterOption('')}
							/>
						)}
						<div>
							{location.pathname === '/' && (
								<IconButton
									size='large'
									aria-label='account of current user'
									aria-controls='menu-appbar'
									aria-haspopup='true'
									onClick={handleMenu}
									color={filterOption ? 'primary' : 'inherit'}
								>
									<FilterList sx={IconFontSizeResponsive} />
								</IconButton>
							)}
							{/* {	location.pathname === '/orders-history' && ( */}
							{(location.pathname === `/${orderId}/edit` ||
								location.pathname === `/${orderId}/view`) && (
								<Grid container>
									<Grid item xs={6}>
										<IconButton
											disabled={
												location.pathname === `/${orderId}/edit` && true
											}
											variant='contained'
											onClick={() => navigate(`/${orderId}/edit`)}
										>
											<Edit sx={IconFontSizeResponsive} />
										</IconButton>
									</Grid>
									<Grid item xs={6}>
										<IconButton
											variant='contained'
											onClick={() => {
												Swal.fire({
													width: 400,
													title: 'Eliminar pedido?',
													text: 'Se eliminará permantemente',
													icon: 'warning',
													showCancelButton: true,
													confirmButtonColor: '#d33',
													cancelButtonColor: '#3085d6',
													confirmButtonText: 'Eliminar',
													cancelButtonText: 'Cancelar',
													customClass: {
														container: 'my-swal',
													},
												}).then(async (result) => {
													if (result.isConfirmed) {
														deleteSpecificOrder(currentOrderId);
														navigate(-1);
													}
												});
											}}
										>
											<Delete sx={IconFontSizeResponsive} />
										</IconButton>
									</Grid>
								</Grid>
							)}

							<Select
								id='menu-appbar'
								anchorEl={anchorEl}
								anchorOrigin={{
									vertical: 'top',
									horizontal: 'right',
								}}
								keepMounted
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right',
								}}
								open={Boolean(anchorEl)}
								onClose={handleClose}
							>
								{filterOptions.map((option) => (
									<MenuItem
										key={option.value}
										selected={option.value === filterOption.value}
										onClick={() => {
											onChangeFilterOption(option);
											setAnchorEl(null);
										}}
									>
										<ListItemIcon>{option.icon}</ListItemIcon>
										{option.label}
									</MenuItem>
								))}
							</Select>
						</div>
					</Toolbar>
				</AppBar>
			</ElevationScroll>
			<Toolbar />
			{children}
			<SwipeableMenu
				drawerIsOpen={drawerIsOpen}
				setDrawerIsOpen={setDrawerIsOpen}
			/>
			<Zoom in={inZoom}>
				<Fab
					onClick={() => toogleNewOrderDialog()}
					color='secondary'
					aria-label='add'
					sx={{
						margin: '0',
						padding: '0',
						position: 'fixed',
						right: '1em',
						bottom: '5em',
					}}
				>
					<Add sx={IconFontSizeResponsive} />
				</Fab>
			</Zoom>
			<Outlet />
		</>
	);
}
